<template>
  <b-container>
    <WizardPageTitle title="Generate & Download Your Project" />
    <div v-if="inflight">
      <b-row>
        <b-col class="text-center mt-4">
          <h4>Please wait</h4>
          <b-spinner class="my-4" />
          <p>
            {{ progressMessage }} ...
          </p>
        </b-col>
      </b-row>
    </div>
    <div v-else-if="!generatedUrl">
      <b-row>
        <b-col>
          <p>
            You're almost done!
          </p>
          <p>
            Add a short description of your change(s), like you would
            in a git commit message, then press <strong>Generate</strong> to
            generate and download your code. This will also save the project
            settings and code in your account for later use.
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form @submit.prevent="generate">
            <b-form-group
              label="Description"
              description="Example: Add a Book model, or Enable Heroku support, or Initial version"
            >
              <b-form-input
                ref="description"
                v-model="description"
              />
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
      <WizardPrevNext>
        <template slot="next">
          <b-button
            variant="primary"
            @click="generate"
          >
            Generate
          </b-button>
        </template>
      </WizardPrevNext>
    </div>
    <div v-else>
      <b-row>
        <b-col class="text-center">
          <h4 class="my-4">
            All done!
          </h4>
          <p>
            New code for your project <strong>{{ recipeName }}</strong> has been generated.
          </p>
          <p>
            <b-button
              :href="generatedUrl"
              variant="primary"
            >
              <b-icon icon="download" />
              Download ZIP archive
            </b-button>
            &nbsp;
            <b-button :href="projectUrl">
              Back to project
            </b-button>
          </p>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex';

import { projectUrl } from '../utils/config';

import WizardPageTitle from './widgets/WizardPageTitle.vue';
import WizardPrevNext from './widgets/WizardPrevNext.vue';
import navigationMixin from './mixins/navigation';


const sleep = seconds => new Promise(resolve => setTimeout(resolve, seconds * 1000));


const mapLocals = (locals) => {
  const functions = {};
  for (const name in locals) {
    functions[name] = () => locals[name];
  }
  return functions;
};


export default {
  name: 'Generate',
  components: {
    WizardPageTitle,
    WizardPrevNext,
  },
  mixins: [navigationMixin],
  data() {
    return {
      inflight: false,
      progressMessage: null,
      description: '',
    };
  },
  computed: {
    ...mapState(['recipe', 'serverError', 'generatedUrl']),
    ...mapLocals({ projectUrl }),
    recipeName() {
      return this.recipe.name;
    },
  },
  async mounted() {
    await this.$nextTick();
    this.$refs.description.focus();
  },
  methods: {
    async generate() {
      this.inflight = true;
      this.generateProgressMessage();
      await this.$store.dispatch('generateProject', this.description);
      this.inflight = false;
    },
    async generateProgressMessage() {
      this.progressMessage = 'Generating code'
      await sleep(2);
      this.progressMessage = 'Setting up Node environment'
      await sleep(7);
      this.progressMessage = 'Running tests'
    },
    commit() {
      // Only allow navigation if code hasn't been generated yet
      return !this.generatedUrl;
    }
  },
};
</script>
